import type { RefObject } from 'react';

import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import type { Timezone } from '@repo/ui/types/timezone';

import './TimezoneListItem.scss';

import { DataTestIds } from '@repo/frontend-shared/data-test-ids';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';

interface TimezoneListProps {
  itemRef: RefObject<HTMLButtonElement | null> | null;
  timezone: Timezone;
  onClick: () => void;
  isSelected: boolean;
}

export function TimezoneListItem({ itemRef, timezone, onClick }: TimezoneListProps) {
  return (
    <SDSPrimitiveButton
      className="TimezoneListItem"
      onClick={onClick}
      buttonRef={itemRef}
      dataTestId={DataTestIds.COMMON.DROPDOWN_ITEM}
    >
      <SDSFlexbox alignItems="center" justifyContent="space-between" fullWidth>
        <SDSText type="body-medium" text={timezone.label} />
        <SDSText type="body-medium" color="muted" text={`(${timezone.offset})`} />
      </SDSFlexbox>
    </SDSPrimitiveButton>
  );
}
